import React from "react";
import Card from "@mui/material/Card";
import { Button, CardActionArea, CardContent, Typography } from "@mui/material";

const ViewMoreCard = ({ t, offerCount, handleClick }) => {
  return (
    <Card sx={{ width: 1, background: "#000000" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
          p: 4,
          height: 230,
        }}
      >
        <Typography
          variant="h5"
          fontSize={"2rem"}
          color="#ffffff"
          fontFamily="Sitka Heading"
          gutterBottom
          mb={1}
        >
          {t("offers")}
        </Typography>
        <Typography
          variant="subtitle1"
          color="#ffffff"
          fontFamily="Sitka Heading"
          gutterBottom
          mb={2}
        >
          {t("offerSubheading1")} {offerCount} {t("offerSubheading2")}
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "16px",borderRadius:"4px" }}
          fontFamily="Poppins"
          onClick={() => handleClick(" ", 2)}
        >
          {t("seeAllOffers")}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ViewMoreCard;
